import { render, staticRenderFns } from "./bktjS.vue?vue&type=template&id=5c98d60d&scoped=true"
import script from "./bktjS.vue?vue&type=script&lang=js"
export * from "./bktjS.vue?vue&type=script&lang=js"
import style0 from "./bktjS.vue?vue&type=style&index=0&id=5c98d60d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c98d60d",
  null
  
)

export default component.exports